import { render } from "./PaginaQuestionario.vue?vue&type=template&id=e45c5cb8"
import script from "./PaginaQuestionario.vue?vue&type=script&lang=js"
export * from "./PaginaQuestionario.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__